<template>
  <v-container>
    <v-card color="transparent" elevation="0">
      <v-card-title class="justify-center">
        {{ $t("pages.favourite") }}
      </v-card-title>
      <v-card-text>
        <template v-if="!favList">
          <h2 class="headline text-center my-10">
            {{ $vuetify.lang.translator("noDataText") }}
          </h2>
          <div class="text-center">
            <v-btn elevation="2" color="primary" dark router to="/">
              <v-icon class="mx-1" small>fa-home</v-icon>
              <span>{{ $t("goToHome") }}</span>
            </v-btn>
          </div>
        </template>
        <template v-else>
          <dikr-list :items="items"></dikr-list>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import DikrList from "@/components/DikrList.vue";

export default {
  components: { DikrList },
  data: () => ({
    favList: false,
    items: [],
  }),
  created() {
    const list = this.$store.getters.getFavList;
    if (!this.isEmpty(list)) {
      list.forEach((el) => {
        this.items.push({ TITLE: el.TITLE, slug: this.kebabCase(el.TITLE) });
      });

      this.favList = this.items.length > 0;
    }
  },
  metaInfo: {
    title: "المفضلة",
    titleTemplate: "حصن مسلم - %s",
  },
};
</script>
